import { Icon } from './Icon';
import { useTranslation } from 'react-i18next';

export default function SearchBar({ search, setSearch, placeholder }) {
  const { t } = useTranslation();
  const ph = placeholder ?? t('table.searchPlaceholder');
  return (
    <div className="relative w-full sm:w-72 h-10">
      <input
        type="text"
        placeholder={ph}
        className="
          pl-10 pr-4 h-10 leading-5
          border border-gray-300
          rounded w-full shadow
          hover:border-gray-400
          focus:border-gray-500 focus:outline-none
        "
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {/* Icona della lente di ingrandimento - centrata verticalmente con inset-y */}
      <div className="absolute left-3 inset-y-0 flex items-center text-gray-500">
        <Icon name="search" />
      </div>
      {search && (
        <button
          type="button"
          onClick={() => setSearch('')}
          className="
            absolute right-3 inset-y-0 flex items-center
            text-xs text-gray-500
            hover:text-gray-700 hover:scale-110
            duration-300
          "
        >
          <Icon name="cross" />
        </button>
      )}
    </div>
  );
};
